// extracted by mini-css-extract-plugin
export default {"buttonWrapper":"Step4_JoinLoyaltyPoints_buttonWrapper__5wSra"};